import { NgModule } from '@angular/core';
import { JtsnxAlertComponent } from './jtsnx-alert.component';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import {DateInputsModule} from '@progress/kendo-angular-dateinputs';

@NgModule({
  declarations: [JtsnxAlertComponent],
  imports: [HttpClientModule, CommonModule, FormsModule, DateInputsModule],
  exports: [JtsnxAlertComponent],
})
export class JtsnxAlertModule {}
